// 3rd party
import React, { ReactElement } from 'react';

// Components
import CartListComponent from 'components/CartListComponent';
import CustomLoader from 'components/CustomLoader';
import { OrderInputWithSFFlag, OrderInputWithPriceInfo } from 'types/parts';
import { CartPriceType } from './helper';
interface Props {
  handleClose?: () => void;
  isCartEmpty?: (status?: boolean) => void;
  cartPriceType?: CartPriceType;
  selectedPriceType?: CartPriceType;
  isLoading?: boolean;
  isFinalEstimationPage?: boolean;
  requestedDate?: string;
  enableProsealTwoWaySync?: boolean;
  orderInputData?: OrderInputWithSFFlag;
  setOrderInputData?: (data: OrderInputWithSFFlag | undefined) => void;
  setOrderPriceInfo?: ({
    pricedInfo,
    nonePricedInfo
  }: {
    pricedInfo?: OrderInputWithPriceInfo;
    nonePricedInfo?: OrderInputWithPriceInfo;
  }) => void;
  setPriceCalculationStatus?: (loading: boolean) => void;
  setSelectedCartPriceType?: (priceType: CartPriceType) => void;
}

const CartStepOne = ({
  handleClose,
  isCartEmpty,
  selectedPriceType,
  isLoading,
  isFinalEstimationPage,
  requestedDate,
  enableProsealTwoWaySync,
  orderInputData,
  setPriceCalculationStatus,
  setOrderInputData,
  setOrderPriceInfo
}: Props): ReactElement => {
  return (
    <>
      {isLoading ? (
        <div>
          <CustomLoader padding="3rem 0" />
        </div>
      ) : (
        <CartListComponent
          isCartEmpty={isCartEmpty}
          handleClose={handleClose}
          viewType="default"
          selectionType={enableProsealTwoWaySync ? 'multi-select' : 'none'}
          selectedPriceType={selectedPriceType}
          isFinalEstimationPage={isFinalEstimationPage}
          requestedDate={requestedDate}
          enableProsealTwoWaySync={enableProsealTwoWaySync}
          orderInputData={orderInputData}
          setOrderInputData={setOrderInputData}
          setOrderPriceInfo={setOrderPriceInfo}
          setPriceCalculationStatus={setPriceCalculationStatus}
        />
      )}
    </>
  );
};

export default CartStepOne;
